
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressItem extends Vue {
  @Prop({ required: true }) title!: string;

  @Prop({ default: '' }) subtitle!: string;

  @Prop({ required: true }) qty!: number;

  @Prop({ default: '#2bc5cb' }) color!: string;
}
